/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LikelyBenefit = {
    properties: {
        id: {
    type: 'number',
},
        benefit: {
    type: 'string',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        count: {
    type: 'number',
},
        createdAt: {
    type: 'string',
},
    },
};